import { module } from 'modujs'
import { html } from '../utils/environment'

export default class extends module {
    constructor(m) {
        super(m)

        this.events = {
            click: {
                close: "close"
            }
        }
    }

    init() {
        this.closeBind = (e) => {
             if (e.key === "Escape") {
                this.close()
            }
        }

        document.addEventListener('keyup', this.closeBind)
    }

    toggle() {
        if (html.classList.contains('has-modal-get-in-touch-open')) {
            this.close()
        } else {
            this.open()
        }
    }

    open() {
        html.classList.add('has-modal-get-in-touch-open')

        requestAnimationFrame(() => {
            this.$('container')[0].scrollTop = 0
        })
    }

    close() {
        this.call('updateAnchor', {obj: this}, 'Scroll')
        html.classList.remove('has-modal-get-in-touch-open')
    }

    destroy() {
        document.removeEventListener('keyup', this.closeBind)
    }
}
